module.exports = __webpack_public_path__ + "static/media/Naydalis P.583aa970.jpeg";